import ReactDOM from "react-dom/client";
import "./index.css";
import "./IF_Swiper.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

reportWebVitals();
